/*! Yubico Japan — see the commented source in the project repository. */
(function () {
  const D = window.YUBI;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const REMOTE_CART = !!window.YUBI_CART_REMOTE;

  const CART_KEY = "yubi_cart_v1";
  const loadCart = () => { try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; } };
  const saveCart = (c) => localStorage.setItem(CART_KEY, JSON.stringify(c));
  let cart = loadCart();

  function findProduct(handle) {
    return D.products[handle] || Object.values(D.products).find((p) => p.handle === handle);
  }

  function addToCart(handle, qty = 1) {
    const p = findProduct(handle);
    if (!p) return;
    const line = cart.find((l) => l.handle === handle);
    if (line) line.qty += qty;
    else cart.push({ handle, qty, name: p.name, price: p.price, img: p.img });
    saveCart(cart); renderCart(); openCart();
  }
  function setQty(handle, qty) {
    const line = cart.find((l) => l.handle === handle);
    if (!line) return;
    line.qty = qty;
    if (line.qty <= 0) cart = cart.filter((l) => l.handle !== handle);
    saveCart(cart); renderCart();
  }

  function renderCart() {
    if (REMOTE_CART) return;
    const count = cart.reduce((s, l) => s + l.qty, 0);
    const subtotal = cart.reduce((s, l) => s + l.qty * l.price, 0);
    $$(".cart-count").forEach((el) => { el.textContent = count; el.dataset.count = count; });
    const title = $("#cartTitle"); if (title) title.textContent = `カート（${count}点）`;
    const body = $("#cartBody"); const foot = $("#cartFoot");
    if (!body) return;
    if (!cart.length) {
      body.innerHTML = `<div class="drawer__empty"><p>カートは空です。</p><p class="muted">気になる製品を追加してみてください。</p></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.map((l) => `
      <div class="cart-line">
        <img class="cart-line__img" src="${l.img}" alt="${l.name}">
        <div style="flex:1">
          <div class="cart-line__name">${l.name}</div>
          <div class="cart-line__price">${window.yen(l.price)} 税込</div>
          <div class="cart-line__foot">
            <span class="qty">
              <button class="js-qty-dec" data-handle="${l.handle}" aria-label="数量を減らす">−</button>
              <span aria-live="polite">${l.qty}</span>
              <button class="js-qty-inc" data-handle="${l.handle}" aria-label="数量を増やす">+</button>
            </span>
            <button class="cart-line__remove js-remove" data-handle="${l.handle}">削除</button>
          </div>
        </div>
      </div>`).join("");
    if (foot) { foot.hidden = false; $("#cartSubtotal").textContent = window.yen(subtotal); }
  }

  let lastFocus = null;
  function openRoot(id) {
    const root = document.getElementById(id);
    if (!root) return;
    lastFocus = document.activeElement;
    root.classList.add("is-open"); root.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const focusable = root.querySelector("input, button, a");
    if (focusable) setTimeout(() => focusable.focus(), 60);
  }
  function closeRoot(id) {
    const root = document.getElementById(id);
    if (!root) return;
    root.classList.remove("is-open"); root.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  const openCart = () => openRoot("cartDrawer");

  let toastTimer;
  function toast(msg) {
    let t = $(".toast");
    if (!t) { t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(() => t.classList.add("is-visible"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("is-visible"), 2400);
  }

  function wire() {
    renderCart();

    document.addEventListener("click", (e) => {
      {
        const cartOpenEl = e.target.closest(".js-cart-open");
        if (cartOpenEl) {
          // The header cart is an <a href="/cart"> so it still works without
          // JS. When JS is present we want the drawer, not a full-page load,
          // so cancel the navigation and open the drawer instead.
          if (cartOpenEl.tagName === "A") e.preventDefault();
          openCart();
        }
      }
      if (e.target.closest(".js-cart-close")) closeRoot("cartDrawer");
      if (e.target.closest(".js-search")) {
        openRoot("searchOverlay");
        const si = $("#siteSearch");
        if (si) setTimeout(() => { si.focus(); si.select(); }, 80);
      }
      if (e.target.closest(".js-search-close")) closeRoot("searchOverlay");
      if (e.target.closest(".js-mobile-open")) openMobile(true);
      if (e.target.closest(".js-mobile-close")) openMobile(false);

      if (REMOTE_CART) return;
      const inc = e.target.closest(".js-qty-inc");
      const dec = e.target.closest(".js-qty-dec");
      const rem = e.target.closest(".js-remove");
      if (inc) setQty(inc.dataset.handle, (cart.find((l) => l.handle === inc.dataset.handle)?.qty || 0) + 1);
      if (dec) setQty(dec.dataset.handle, (cart.find((l) => l.handle === dec.dataset.handle)?.qty || 0) - 1);
      if (rem) { setQty(rem.dataset.handle, 0); toast("カートから削除しました"); }
    });

    // No theme-side max: Shopify inventory rules decide the limit (errors surface via toast).
    const QTY_MIN = 1, QTY_MAX = Infinity;
    function readQty(btn) {
      const id = btn.dataset.qtyFor;
      if (!id) return 1;
      const input = document.getElementById(id);
      const n = parseInt(input && input.value, 10);
      return Number.isFinite(n) ? Math.min(QTY_MAX, Math.max(QTY_MIN, n)) : 1;
    }
    document.addEventListener("click", (e) => {
      const step = e.target.closest(".js-qty-step");
      if (!step) return;
      const input = document.getElementById(step.dataset.qtyTarget);
      if (!input) return;
      const n = parseInt(input.value, 10);
      input.value = Math.min(QTY_MAX, Math.max(QTY_MIN,
        (Number.isFinite(n) ? n : 1) + parseInt(step.dataset.step, 10)));
    });

    document.addEventListener("change", (e) => {
      const input = e.target.closest(".qty__input");
      if (!input) return;
      const n = parseInt(input.value, 10);
      input.value = Number.isFinite(n) ? Math.min(QTY_MAX, Math.max(QTY_MIN, n)) : 1;
    });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-buy]");
      if (!btn || REMOTE_CART) return;
      e.preventDefault();
      addToCart(btn.dataset.buy, readQty(btn));
      closeRoot("cartDrawer");
      location.href = "checkout.html";
    });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-add]");
      if (!btn || REMOTE_CART) return;
      e.preventDefault();
      if (btn.classList.contains("is-loading")) return;
      const handle = btn.dataset.add;
      btn.classList.add("is-loading");
      setTimeout(() => {
        btn.classList.remove("is-loading");
        btn.classList.add("is-success");
        const label = btn.querySelector(".btn__label");
        const prev = label ? label.textContent : btn.textContent;
        if (label) label.textContent = "追加しました"; else btn.textContent = "追加しました";
        addToCart(handle, readQty(btn));
        setTimeout(() => {
          btn.classList.remove("is-success");
          if (label) label.textContent = prev; else btn.textContent = prev;
        }, 1400);
      }, 500);
    });

    const header = $("#siteHeader");
    const mega = $("#megaMenu");
    const trigger = $(".js-mega-trigger");
    if (mega && trigger && header) {
      let hoverTimer;
      const open = () => { clearTimeout(hoverTimer); mega.classList.add("is-open"); header.classList.add("has-open-menu"); trigger.setAttribute("aria-expanded", "true"); };
      const close = () => { hoverTimer = setTimeout(() => { mega.classList.remove("is-open"); header.classList.remove("has-open-menu"); trigger.setAttribute("aria-expanded", "false"); }, 120); };
      [trigger, mega].forEach((el) => { el.addEventListener("mouseenter", open); el.addEventListener("mouseleave", close); });
      trigger.addEventListener("focus", open);
      trigger.addEventListener("click", (e) => {
        if (window.matchMedia("(min-width:1025px)").matches) { e.preventDefault(); mega.classList.contains("is-open") ? close() : open(); }
      });
      document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
    }

    /* Nav sub-dropdowns (e.g. はじめかた → セットアップガイド・Yubico Authenticator).
       CSS alone drops the dropdown when :hover briefly transitions between
       parent and dropdown at fast cursor speeds. JS gives us a 200ms grace
       period after mouseleave, so the panel stays hit-testable for cursor
       intent recovery. Same pattern as the mega-menu above. */
    $$(".nav__item--has-sub").forEach((item) => {
      const dropdown = item.querySelector(".nav__dropdown");
      const link = item.querySelector(".nav__link--has-menu");
      if (!dropdown || !link) return;
      let closeTimer;
      const open = () => {
        clearTimeout(closeTimer);
        item.classList.add("is-open");
        link.setAttribute("aria-expanded", "true");
      };
      const close = () => {
        closeTimer = setTimeout(() => {
          item.classList.remove("is-open");
          link.setAttribute("aria-expanded", "false");
        }, 200);
      };
      [item, dropdown].forEach((el) => {
        el.addEventListener("mouseenter", open);
        el.addEventListener("mouseleave", close);
      });
      link.addEventListener("focus", open);
      dropdown.querySelectorAll("a").forEach((a) => {
        a.addEventListener("focus", open);
        a.addEventListener("blur", close);
      });
    });

    $$(".js-mnav-toggle").forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".mnav-item");
        const open = item.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    });

    $$(".js-mnav-series").forEach((btn) => {
      btn.addEventListener("click", () => {
        const group = btn.closest(".mnav-series-group");
        const wasOpen = group.classList.contains("is-open");
        $$(".mnav-series-group").forEach((g) => {
          g.classList.remove("is-open");
          const b = g.querySelector(".js-mnav-series");
          if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!wasOpen) {
          group.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");

          btn.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
      });
    });

    $$(".js-newsletter, .js-newsletter-main").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const input = form.querySelector("input[type=email]");
        if (input && input.value && input.checkValidity()) { toast("登録ありがとうございます"); input.value = ""; }
        else { toast("メールアドレスをご確認ください"); input?.focus(); }
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") { closeRoot("cartDrawer"); closeRoot("searchOverlay"); openMobile(false); }
    });
  }

  function openMobile(open) {
    const mn = $("#mobileNav");
    const toggle = $(".js-mobile-open");
    if (!mn) return;
    mn.classList.toggle("is-open", open);
    mn.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.style.overflow = open ? "hidden" : "";
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function stickyHeader() {
    const header = $("#siteHeader");
    if (!header) return;
    const onScroll = () => header.classList.toggle("is-stuck", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function scrollReveal() {
    const els = $$(".reveal").filter((e) => !e.classList.contains("is-visible"));
    if (!("IntersectionObserver" in window) || !els.length) {
      els.forEach((e) => e.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
      });
    }, { threshold: 0, rootMargin: "0px 0px -40px 0px" });

    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    els.forEach((e) => {
      const box = e.getBoundingClientRect();
      if (box.top < viewportH && box.bottom > 0) { e.classList.add("is-visible"); return; }
      if (box.bottom <= 0) { e.classList.add("is-visible"); return; }
      io.observe(e);
    });
  }

  window.YubiReveal = scrollReveal;

  function initTabs() {
    $$(".tabs").forEach((tabs) => {
      const tabBtns = $$(".tabs__tab", tabs);
      const panels = $$(".tabs__panel", tabs);
      tabBtns.forEach((btn) => btn.addEventListener("click", () => {
        tabBtns.forEach((b) => b.setAttribute("aria-selected", "false"));
        panels.forEach((p) => (p.hidden = true));
        btn.setAttribute("aria-selected", "true");
        const panel = $("#" + btn.getAttribute("aria-controls"));
        if (panel) panel.hidden = false;
      }));
    });
  }

  function initGallery() {
    const gallery = $("[data-gallery]");
    if (!gallery) return;
    const stage = $(".gallery__main", gallery);
    const main = $(".gallery__main img", gallery);
    const thumbs = $$(".gallery__thumb", gallery);
    const counter = $(".gallery__counter", gallery);
    const prev = $(".gallery__arrow--prev", gallery);
    const next = $(".gallery__arrow--next", gallery);
    if (!thumbs.length || gallery.dataset.galleryInit) return;
    gallery.dataset.galleryInit = "1";

    const strip = $(".gallery__thumbs", gallery);
    let idx = 0;
    function keepThumbInView() {
      if (!strip) return;
      const t = thumbs[idx];
      const left = t.offsetLeft;
      const right = left + t.offsetWidth;

      if (left < strip.scrollLeft) strip.scrollTo({ left: left - 12, behavior: "smooth" });
      else if (right > strip.scrollLeft + strip.clientWidth) {
        strip.scrollTo({ left: right - strip.clientWidth + 12, behavior: "smooth" });
      }
    }

    function refit() {
      main.removeAttribute("data-fit");
      main.style.removeProperty("--fit-s");
      main.style.removeProperty("--fit-x");
      main.style.removeProperty("--fit-y");
      if (window.YUBIFIT) window.YUBIFIT.apply(gallery);

      const stage = main.parentElement;
      if (stage && window.YUBI && window.YUBI.isPhotoSlide) {
        stage.classList.toggle("gallery__main--photo", window.YUBI.isPhotoSlide(main.src));
      }
    }

    // Guards against out-of-order swaps: a fast click/swipe sequence used to
    // queue several 160ms timeouts that resolved in any order, so the stage
    // could land on the wrong slide. Each request takes a token; newest wins.
    let swapToken = 0;
    function setActive(i) {
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach((t, j) => t.setAttribute("aria-pressed", j === idx ? "true" : "false"));
      keepThumbInView();
      if (counter) counter.textContent = (idx + 1) + "/" + thumbs.length;
      const timg = thumbs[idx].querySelector("img");
      // Use the full-resolution URL when the thumb carries one, so the main
      // stage is never a 200px thumbnail upscaled to ~1400px (blurry).
      const src = timg.getAttribute("data-full") || timg.src;
      // The Liquid <img> ships a srcset/sizes tuned to the UNzoomed 560px slot;
      // left in place the browser keeps choosing the ~600px candidate and
      // ignores our full-res src, so imagefit then magnifies a 600px image up
      // to 4x (blurry). Drop srcset/sizes so the full-res src actually wins.
      main.removeAttribute("srcset");
      main.removeAttribute("sizes");
      if ((main.getAttribute("src") || "") === src) { refit(); main.style.opacity = "1"; return; }
      const myToken = ++swapToken;
      // Preload, then paint in one frame — no artificial 160ms delay (removes
      // the "slight lag") and no half-loaded flash. Only the newest request
      // paints, so scrolling/clicking fast can't land on the wrong photo.
      const pre = new Image();
      const paint = () => {
        if (myToken !== swapToken) return;
        main.src = src;
        refit();
        main.style.opacity = "1";
      };
      main.style.opacity = "0";
      pre.onload = paint;
      pre.onerror = paint;
      pre.src = src;
      if (pre.complete) paint();
    }
    thumbs.forEach((t, i) => t.addEventListener("click", () => setActive(i)));
    if (prev) prev.addEventListener("click", () => setActive(idx - 1));
    if (next) next.addEventListener("click", () => setActive(idx + 1));

    if (stage) {
      let startX = 0, startY = 0, dx = 0, dragging = false, decided = false;
      const THRESHOLD = 44;

      const setDrag = (px) => main.style.setProperty("--drag", px + "px");

      const end = (commit) => {
        if (!dragging) return;
        dragging = false;
        stage.classList.remove("is-dragging");
        setDrag(0);
        if (commit && Math.abs(dx) > THRESHOLD) setActive(dx < 0 ? idx + 1 : idx - 1);
        dx = 0;
      };

      stage.addEventListener("pointerdown", (e) => {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        if (e.target.closest(".gallery__arrow")) return;
        dragging = true; decided = false;
        startX = e.clientX; startY = e.clientY; dx = 0;
      });
      stage.addEventListener("pointermove", (e) => {
        if (!dragging) return;
        const mx = e.clientX - startX;
        const my = e.clientY - startY;
        if (!decided) {
          if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;

          if (Math.abs(my) > Math.abs(mx)) { dragging = false; return; }
          decided = true;
          stage.classList.add("is-dragging");
          stage.setPointerCapture(e.pointerId);
        }
        dx = mx;

        const atEnd = (dx > 0 && idx === 0) || (dx < 0 && idx === thumbs.length - 1);
        setDrag(dx * (atEnd ? 0.28 : 0.6));
      });
      stage.addEventListener("pointerup", () => end(true));
      stage.addEventListener("pointercancel", () => end(false));
      stage.addEventListener("pointerleave", () => end(false));

      stage.addEventListener("click", (e) => {
        if (stage.classList.contains("is-dragging")) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      stage.addEventListener("dragstart", (e) => e.preventDefault());
    }

    refit();
    setActive(0);
  }

  function initStickyBuy() {
    const bar = $(".sticky-buy");
    const anchor = $("[data-buy-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    document.body.classList.add("has-sticky-buy");
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => bar.classList.toggle("is-visible", !en.isIntersecting));
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function initCarousel(track, dotsEl, prevBtn, nextBtn) {
    if (!track || !track.children.length) return;
    function step() {
      const c = track.children[0];
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 24;
      return c ? c.getBoundingClientRect().width + gap : 320;
    }
    function visible() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function positions() { return Math.max(1, track.children.length - visible() + 1); }
    function current() { return Math.min(positions() - 1, Math.round(track.scrollLeft / step())); }
    function buildDots() {
      if (!dotsEl) return;
      const n = positions();
      dotsEl.innerHTML = "";
      for (let i = 0; i < n; i++) {
        const b = document.createElement("button");
        b.className = "lineup-dot"; b.type = "button";
        b.setAttribute("role", "tab");
        b.setAttribute("aria-label", (i + 1) + "番目へ");
        b.dataset.i = i;
        dotsEl.appendChild(b);
      }
    }
    function update() {
      const cur = current();
      if (dotsEl) $$(".lineup-dot", dotsEl).forEach((d, i) => d.setAttribute("aria-current", i === cur ? "true" : "false"));
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
    }
    function goTo(i) { track.scrollTo({ left: Math.max(0, i) * step(), behavior: "smooth" }); }
    if (prevBtn) prevBtn.addEventListener("click", () => goTo(current() - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(current() + 1));
    if (dotsEl) dotsEl.addEventListener("click", (e) => { const b = e.target.closest(".lineup-dot"); if (b) goTo(parseInt(b.dataset.i, 10)); });
    track.addEventListener("scroll", () => requestAnimationFrame(update), { passive: true });
    window.addEventListener("resize", () => { buildDots(); update(); });
    buildDots(); update();
  }
  window.initCarousel = initCarousel;

  /* Auto-wire any [data-carousel] track using the Y.carousel id convention
     (id, idDots, idPrev, idNext). Used by the homepage series lineup and the
     PDP related-products carousel, which are server- or JS-rendered rather than
     built by the prototype's initCarouselById. Idempotent via a dataset flag. */
  function initCarousels(root) {
    $$("[data-carousel]", root || document).forEach((track) => {
      if (track.dataset.carouselInit) return;
      track.dataset.carouselInit = "1";
      const id = track.id;
      initCarousel(
        track,
        id ? document.getElementById(id + "Dots") : null,
        id ? document.getElementById(id + "Prev") : null,
        id ? document.getElementById(id + "Next") : null
      );
    });
  }
  window.initCarousels = initCarousels;
  window.addEventListener("pdp:enriched", () => { initCarousels(); if (typeof scrollReveal === "function") scrollReveal(); });

  function stepProgressGeometry(firstMid, lastMid, viewportH) {
    const span = lastMid - firstMid;
    if (!(span > 0)) return null;
    const readingLine = viewportH * 0.6;
    const ratio = Math.max(0, Math.min(1, (readingLine - firstMid) / span));
    return { span, readingLine, ratio, filled: ratio * span };
  }
  window.__stepProgressGeometry = stepProgressGeometry;

  function initStepProgress(list) {
    if (!list || list.dataset.progressInit) return;
    list.dataset.progressInit = "1";
    const fill = list.querySelector(".setup-steps__fill");
    const steps = $$(".setup-step", list);
    if (!fill || !steps.length) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      steps.forEach((s) => s.classList.add("is-reached"));
      return;
    }

    let ticking = false;
    function update() {
      ticking = false;
      const first = steps[0].querySelector(".setup-step__num");
      const last = steps[steps.length - 1].querySelector(".setup-step__num");
      if (!first || !last) return;
      const firstBox = first.getBoundingClientRect();
      const lastBox = last.getBoundingClientRect();
      const mid = (b) => b.top + b.height / 2;
      const geom = stepProgressGeometry(mid(firstBox), mid(lastBox), window.innerHeight);
      if (!geom) return;
      fill.style.height = geom.filled + "px";
      steps.forEach((s) => {
        const m = s.querySelector(".setup-step__num").getBoundingClientRect();
        s.classList.toggle("is-reached", mid(m) <= geom.readingLine + 1);
      });
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    let listening = false;
    const bind = (on) => {
      if (on === listening) return;
      listening = on;
      if (on) {
        window.addEventListener("scroll", onScroll, { passive: true });
        window.addEventListener("resize", onScroll, { passive: true });
        update();
      } else {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
      }
    };
    update();
    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => bind(en.isIntersecting));
      }, { rootMargin: "200px 0px" }).observe(list);
    } else {
      bind(true);
    }
  }
  window.initStepProgress = initStepProgress;

  function applyFieldRules(el) {
    if (!el || !el.dataset || !el.dataset.digits) return;
    el.setCustomValidity("");
    var value = String(el.value || "").trim();
    if (!value) return;
    var range = el.dataset.digits.split(",");
    var min = parseInt(range[0], 10);
    var max = parseInt(range[1] != null ? range[1] : range[0], 10);
    var digits = value.replace(/[^0-9]/g, "").length;

    if (/[０-９]/.test(value)) {
      el.setCustomValidity("半角数字でご入力ください。");
      return;
    }
    if (digits < min || digits > max) {
      el.setCustomValidity(min === max
        ? "半角数字" + min + "桁でご入力ください。"
        : "半角数字" + min + "〜" + max + "桁でご入力ください。");
    }
  }
  window.YubiFieldRules = applyFieldRules;

  function enhanceSelect(select) {
    if (!select || select.dataset.cddInit) return;
    select.dataset.cddInit = "1";

    const wrap = document.createElement("div");
    wrap.className = "cdd";
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add("cdd__native");

    const chev = '<svg class="cdd__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
    const ui = document.createElement("div");
    ui.innerHTML =
      '<button class="cdd__trigger" type="button" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="cdd__value"></span>' + chev +
      '</button>' +
      '<div class="cdd__panel" role="listbox"></div>';
    while (ui.firstChild) wrap.appendChild(ui.firstChild);

    const trigger = wrap.querySelector(".cdd__trigger");
    const panel = wrap.querySelector(".cdd__panel");
    const valueEl = wrap.querySelector(".cdd__value");
    if (select.id) trigger.setAttribute("aria-labelledby", "lbl-" + select.id);

    function options() { return Array.prototype.slice.call(select.options); }

    function paint() {
      const sel = select.options[select.selectedIndex];
      valueEl.textContent = sel ? sel.text : "";

      valueEl.classList.toggle("cdd__value--placeholder", !select.value);
      panel.innerHTML = options().map((o) =>
        '<button class="cdd__option" type="button" role="option" data-value="' +
        o.value.replace(/"/g, "&quot;") + '"' +
        (o.value === select.value ? ' aria-selected="true"' : "") + '>' + o.text + '</button>'
      ).join("");
    }

    const close = () => { wrap.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); };
    const open = () => {

      $$(".cdd.is-open").forEach((el) => {
        if (el === wrap) return;
        el.classList.remove("is-open");
        const t = el.querySelector(".cdd__trigger");
        if (t) t.setAttribute("aria-expanded", "false");
      });
      wrap.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };

    trigger.addEventListener("click", () => (wrap.classList.contains("is-open") ? close() : open()));
    panel.addEventListener("click", (e) => {
      const opt = e.target.closest(".cdd__option");
      if (!opt) return;
      select.value = opt.dataset.value;

      select.dispatchEvent(new Event("change", { bubbles: true }));
      paint();
      close();
      trigger.focus();
    });
    document.addEventListener("click", (e) => { if (!wrap.contains(e.target)) close(); });
    trigger.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowDown" || e.key === "Enter" || e.key === " ") { e.preventDefault(); open(); }
    });

    select.addEventListener("change", paint);
    select.form && select.form.addEventListener("reset", () => setTimeout(paint, 0));

    paint();
    return { repaint: paint };
  }

  function enhanceMarkedSelects(root) {
    $$("select[data-cdd]", root || document).forEach(enhanceSelect);
  }
  window.YubiSelect = { enhance: enhanceSelect, enhanceAll: enhanceMarkedSelects };

  /* The search index is built from window.YUBI, whose hrefs and image paths are
     the static prototype's (product.html?p=…, assets/img/…). Rewrite both to the
     Shopify storefront the same way collection-enrich.js does, so a search hit
     opens the real product/collection/page and its thumbnail actually loads. */
  const SEARCH_ASSET_BASE = window.ASSET_BASE || "";
  function searchAsset(src) {
    if (!src) return src;
    if (/^https?:|^\/\//.test(src)) return src;
    const m = String(src).match(/assets\/img\/(.+)$/);
    return m ? SEARCH_ASSET_BASE + m[1].replace(/\//g, "-") : src;
  }
  const SEARCH_PAGE = {
    "how-to-choose.html": "/pages/how-to-choose",
    "set-up-yubikey.html": "/pages/setup",
    "what-is-yubikey.html": "/pages/how-the-yubikey-works",
    "works-with.html": "/pages/computer-login-tools",
    "faq.html": "/pages/contact",
    "about.html": "/pages/why-yubico",
    "blog.html": "/blogs/news",
    "products.html": "/collections",
    "index.html": "/"
  };
  function searchRoute(href) {
    if (!href) return "#";
    if (/^https?:|^mailto:|^#/.test(href)) return href;
    const base = href.split("#")[0];
    let m = base.match(/product\.html\?p=([\w-]+)/); if (m) return "/products/" + m[1];
    if (/^article\.html/.test(base)) return "/blogs/news";
    if (SEARCH_PAGE[base]) return SEARCH_PAGE[base];
    m = base.match(/^yubihsm-series\.html$/); if (m) return "/collections/yubihsm-2-series";
    m = base.match(/^([\w-]+)-series\.html$/); if (m) return "/collections/" + m[1] + "-series";
    return href;
  }

  function buildSearchIndex() {
    const items = [];
    Object.keys(D.products).forEach((k) => {
      const p = D.products[k];
      items.push({ group: "製品", label: p.name, href: p.href, thumb: p.img,
                   keys: [p.name, p.series, (p.connections || []).join(" "), p.short || ""].join(" ") });
    });
    D.series.forEach((s2) => {
      items.push({ group: "シリーズ", label: s2.name, href: s2.href, thumb: s2.img,
                   keys: [s2.name, s2.desc || ""].join(" ") });
    });
    [
      { label: "YubiKeyの選び方（診断）", href: "how-to-choose.html", keys: "選び方 診断 えらびかた quiz おすすめ" },
      { label: "YubiKeyのセットアップ", href: "set-up-yubikey.html", keys: "セットアップ 設定 はじめかた setup 登録" },
      { label: "YubiKeyとは？", href: "what-is-yubikey.html", keys: "とは 基本 パスキー passkey しくみ" },
      { label: "対応サービス・アプリ・ツール", href: "works-with.html", keys: "対応 サービス アプリ ツール works with 互換" },
      { label: "サポート・よくあるご質問", href: "faq.html", keys: "よくある 質問 FAQ サポート 問い合わせ" },
      { label: "会社情報", href: "about.html", keys: "会社 について Yubico ミッション" },
    ].forEach((g) => items.push(Object.assign({ group: "ガイド" }, g)));
    (D.blog || []).forEach((b, i) => {
      items.push({ group: "ブログ", label: b.title, href: "article.html?i=" + i, thumb: b.img,
                   keys: [b.title, b.excerpt || "", b.tag || ""].join(" ") });
    });
    // Rewrite every hit's link and thumbnail to the Shopify storefront.
    items.forEach((it) => { it.href = searchRoute(it.href); it.thumb = searchAsset(it.thumb); });
    return items;
  }

  function initSearch() {
    const input = $("#siteSearch");
    const out = $("#searchResults");
    if (!input || !out) return;
    const index = buildSearchIndex();
    const arrow = '<svg class="search-hit__arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M3 12H21M12.5 20.5L21 12L12.5 3.5" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    function render(q) {
      const term = q.trim().toLowerCase();
      if (!term) { out.innerHTML = ""; return; }
      const hits = index.filter((it) => it.keys.toLowerCase().indexOf(term) >= 0).slice(0, 12);
      if (!hits.length) {
        out.innerHTML = '<p class="search-empty">「' + q + '」に一致する結果は見つかりませんでした。別のキーワードでお試しください。</p>';
        return;
      }
      const groups = {};
      hits.forEach((h) => { (groups[h.group] = groups[h.group] || []).push(h); });
      out.innerHTML = ["製品", "シリーズ", "ガイド", "ブログ"].filter((g) => groups[g]).map((g) =>
        '<div class="search-group"><p class="search-group__title">' + g + '</p>' +
        groups[g].map((h) =>
          '<a class="search-hit" href="' + h.href + '">' +
            (h.thumb ? '<span class="search-hit__thumb"><img src="' + h.thumb + '" alt="" loading="lazy"></span>' : '') +
            '<span>' + h.label + '</span>' + arrow +
          '</a>').join("") +
        '</div>').join("");
    }
    input.addEventListener("input", () => render(input.value));

    input.addEventListener("search", () => render(input.value));
  }

  function initMetrics(list) {
    if (!list || list.dataset.metricsInit) return;
    list.dataset.metricsInit = "1";
    const items = $$(".metric", list);
    if (!items.length) return;

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced || !("IntersectionObserver" in window)) return;

    list.classList.add("metrics--armed");

    function countUp(el) {
      const target = parseInt(el.dataset.countTo, 10);
      const suffix = el.dataset.suffix || "";
      if (!Number.isFinite(target)) return;
      const final = el.textContent;
      const start = performance.now();
      const dur = 900;
      (function step(now) {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = final;
      })(start);
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (!en.isIntersecting) return;
        items.forEach((el, i) => {
          setTimeout(() => {
            el.classList.add("is-in");
            const v = el.querySelector("[data-count-to]");
            if (v) countUp(v);
          }, i * 90);
        });
        io.disconnect();
      });
    }, { threshold: 0.3 });
    io.observe(list);
  }
  window.initMetrics = initMetrics;

  const MARQUEE_PX_PER_SEC = 34;
  function pace(track, sets) {
    if (!track) return;
    const setWidth = track.scrollWidth / sets;
    if (!setWidth) return;
    track.style.animationDuration = (setWidth / MARQUEE_PX_PER_SEC).toFixed(1) + "s";
  }
  function paceMarquees() {

    pace(document.querySelector(".trusted__track"), 3);
    pace(document.querySelector(".wwm__track"), 3);
  }

  function initAfterShell() {
    wire();
    enhanceMarkedSelects();
    stickyHeader();
    initSearch();
    initStepProgress(document.getElementById("setupSteps"));
    initMetrics(document.getElementById("companyMetrics"));
    initCarousels();

    paceMarquees();
    window.addEventListener("load", paceMarquees);
  }

  if (window.__shellReady) initAfterShell();
  else window.addEventListener("shell:ready", initAfterShell);

  document.addEventListener("DOMContentLoaded", () => { scrollReveal(); initTabs(); initGallery(); initStickyBuy(); initCarousels(); });
  window.addEventListener("pdp:rendered", () => { initGallery(); initStickyBuy(); scrollReveal(); initCarousels(); });
  window.addEventListener("series:rendered", () => { scrollReveal(); initTabs(); });

  window.YubiUI = { addToCart, toast };

  if (!REMOTE_CART) window.YubiCart = {
    items: () => cart.slice(),

    setQty: (handle, qty) => setQty(handle, qty),
    subtotal: () => cart.reduce((s, l) => s + l.qty * l.price, 0),
    count: () => cart.reduce((s, l) => s + l.qty, 0),
    clear: () => { cart = []; saveCart(cart); renderCart(); },
  };

  /* ---- GA4 nav/mega/footer click tracking (added 2026-09-01) ---- */
  /* GA4_NAV_TRACKING marker */
  (function () {
    function pushDL(payload) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (e) {}
    }
    function seriesFromHref(href) {
      if (!href) return undefined;
      var m = /\/collections\/([a-z0-9-]+)/i.exec(href);
      return m ? m[1] : undefined;
    }
    function productHandleFromHref(href) {
      if (!href) return undefined;
      var m = /\/products\/([a-z0-9-]+)/i.exec(href);
      return m ? m[1] : undefined;
    }
    document.addEventListener("click", function (e) {
      var el = e.target;

      // Mega-menu product tile
      var tile = el.closest && el.closest(".mega-tile");
      if (tile) {
        pushDL({
          event: "mega_menu_product_click",
          product_handle: productHandleFromHref(tile.getAttribute("href")),
          product_name: (tile.querySelector(".mega-tile__title") || tile).textContent.trim().slice(0, 80),
          series: undefined
        });
        return;
      }

      // Mega-menu series title (column header)
      var gt = el.closest && el.closest(".mega-group__title--link");
      if (gt) {
        pushDL({
          event: "mega_menu_series_click",
          series: seriesFromHref(gt.getAttribute("href")),
          series_label: gt.textContent.trim().slice(0, 60)
        });
        return;
      }

      // Nav dropdown sub-link
      var dl = el.closest && el.closest(".nav__dropdown-link");
      if (dl) {
        pushDL({
          event: "nav_click",
          nav_type: "dropdown",
          nav_label: dl.textContent.trim().slice(0, 60),
          nav_href: dl.getAttribute("href")
        });
        return;
      }

      // Top-level nav link (skip if inside dropdown / mega tile — already handled above)
      var nl = el.closest && el.closest(".nav__link");
      if (nl && !el.closest(".megamenu") && !el.closest(".nav__dropdown")) {
        pushDL({
          event: "nav_click",
          nav_type: "top",
          nav_label: (nl.textContent || "").trim().slice(0, 60),
          nav_href: nl.getAttribute("href")
        });
        return;
      }

      // Footer link
      var flink = el.closest && el.closest(".footer a[href]");
      if (flink) {
        var col = flink.closest("[data-footer-col], .footer__col");
        pushDL({
          event: "footer_link_click",
          footer_label: flink.textContent.trim().slice(0, 60),
          footer_href: flink.getAttribute("href"),
          footer_section: col ? (col.getAttribute("data-footer-col") || (col.querySelector("h3,h4") || {}).textContent || "").trim() : undefined
        });
        return;
      }
    }, true /* capture: fire before other click handlers cancel */);
  })();

})();
